<template>
  <div class="crop">
    <a-collapse v-model:activeKey="activeKey" :bordered="true" :ghost="false" accordion>
      <a-collapse-panel key="ratio" :header="t('crop.ratioAdjustment')">
        <a-list class="list" size="small" bordered :data-source="sizeList">
          <template #renderItem="{ item }">
            <a-list-item :class="{ selected: appState.cropInfoTemp.ratioValue === item.value }" @click="doSelect(item)">
              {{ item.label }}
            </a-list-item>
          </template>
        </a-list>
        <div class="flex justify-between mt-4">
          <span class="mr-1">
            <a-input readonly :value="parseInt(appState.cropInfoTemp.width)" :addon-after="t('crop.width')" />
          </span>
          <span class="ml-1">
            <a-input readonly :value="parseInt(appState.cropInfoTemp.height)" :addon-after="t('crop.height')" />
          </span>
        </div>
        <a-alert type="info" class="!mt-4" showIcon :message="t('crop.tip')"></a-alert>
        <div class="flex mt-4">
          <a-button class="mr-2 flex-grow" @click="cancel">{{ t('common.cancel') }}</a-button>
          <a-button type="primary" class="flex-grow" @click="applyCrop">{{ t('common.apply') }}</a-button>
        </div>
      </a-collapse-panel>
      <!-- <a-collapse-panel key="size" header="宽高调整">
        <a-list class="list" size="small" bordered :data-source="sizeList">
          <template #renderItem="{ item }">
            <a-list-item :class="{ selected: appState.cropInfoTemp.ratioValue === item.value }" @click="doSelect(item)">
              {{ item.label }}
            </a-list-item>
          </template>
        </a-list>
      </a-collapse-panel> -->
    </a-collapse>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { getCroppedImage, getRecordState } from '@/utils';
import { sendLog } from '@/utils/sentry';
import i18n from '@/locales/i18n';

const { t } = i18n.global;

const emit = defineEmits(['cancel']);
const store = useStore();
const appState = computed(() => store.state.app);
const activeKey = ref('ratio');
const sizeList = [
  { value: 'custom', label: t('crop.freeCropping') },
  { value: 'original', label: t('crop.originalImage') },
  { value: 1, label: '1:1' },
  { value: 2 / 3, label: '2:3' },
  { value: 3 / 2, label: '3:2' },
  { value: 3 / 4, label: '3:4' },
  { value: 4 / 3, label: '4:3' },
  { value: 9 / 16, label: '9:16' },
  { value: 16 / 9, label: '16:9' },
];
const doSelect = item => {
  const { value, label } = item;
  const result = { ratioLabel: label, ratioValue: value, changeFlag: +new Date() };
  store.commit('app/patchCropInfo', [result, true]);
  sendLog(`crop:${label}`);
};

const cancel = () => {
  emit('cancel');
};
const applyCrop = () => {
  store.commit('app/patchCropInfo', [appState.value.cropInfoTemp]);
  emit('cancel');
  store.commit('app/SET_STATE', {
    cropOriginImage: getCroppedImage(document.querySelector('#J-original-img'), appState.value.cropInfoTemp),
    // cropRmImage: getCroppedImage(document.querySelector('#J-rm-img'), appState.value.cropInfoTemp),
  });
  // 记录裁剪状态
  store.dispatch('record/addState', getRecordState(appState.value), { root: true });
};
</script>

<style lang="less" scoped>
.list {
  height: 280px;
  overflow: auto;
}
.crop {
  height: 100%;
  ::v-deep(.ant-list-item) {
    cursor: pointer;
    transition: background-color 0.15s;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
    &.selected {
      color: @primary-color;
      font-weight: bold;
    }
  }
}
</style>
